import React from 'react'
import Hero from './Hero'
import Feature from './Feature'
import Fruitshop from './Fruitshop'
import Feature1 from './Feature1'
// import Vegetables from './Vegetables'
import Banner from './Banner'
import Bestsaler from './Bestsaler'
import Fact from './Fact'
import Testimonials from './Testimonials'

function Home() {
  return (
    <>
    <Hero/>
    <Feature/>
    <Fruitshop/>
    <Feature1/>
    {/* <Vegetables/> */}
    <Banner/>
    <Bestsaler/>
    <Fact/>
    <Testimonials/>

    </>
  )
}

export default Home
